import { withStyles } from '@material-ui/core/styles';

const styled = withStyles(theme => {
  return {
    root: {},
    toolbar: {
      justifyContent: 'space-between'
    },
    formControl: {
      margin: theme.spacing.unit,
      minWidth: 80
    },
    tableContainer: {
      overflowX: 'auto',
      marginTop: 30,
      marginBottom: 30,
    },
    table: {
      // maxWidth: 600,
      margin: '0px auto'
    },
    timeAgo: {
      whiteSpace: 'nowrap'
    },
    user: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    type: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }
  };
});

export default styled;
